import { createSelector } from 'reselect'
import { get } from 'lodash'

const snackbarState = (state) => get(state, 'snackbar')

const getSnackbarState = () =>
  createSelector(snackbarState, (snackbar) => snackbar)

export { getSnackbarState }
